import { render, staticRenderFns } from "./SeloProtocolo.vue?vue&type=template&id=3f995279"
import script from "./SeloProtocolo.vue?vue&type=script&lang=ts"
export * from "./SeloProtocolo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports